import ApiService from "../common/apiService";
import {formatDate} from "../common/formatting";
import constants from "../common/constants";
import { forceDownload,filePreview, filePath } from "@/common/documentFunctions";

const MeetingDocumentsModule = {
    state: {
        selected: {
          rootFolder: 0,
          subFolder: 0,
          documents: []
        },
        rootFolders: [],
        subFolders: [],
        documents: [],
        recentDocumentTableRow: [],
    },
    getters: {
    },
    mutations: {
        CLEAR_SELECTED_DOCUMENTS: (state) => {
          state.selected.documents = [];
        },
      CLEAR_SELECTED_ROOT_FOLDER: (state) => {
        state.selected.rootFolder = 0;
      },
      CLEAR_SELECTED_SUB_FOLDER: (state) => {
        state.selected.subFolder = 0;
      },
        CLEAR_DOCUMENTS: (state) => {
          state.documents = [];
        },
        CLEAR_SUB_FOLDERS: (state) => {
          state.subFolders = [];
        },
        SET_RECENT_DOCUMENTS: (state, payload) => {
          state.recentDocumentTableRow = payload;
        },
        SET_SELECTED_ROOT_FOLDER: (state, payload) => {
          state.selected.rootFolder = payload;
        },
        SET_SELECTED_SUB_FOLDER: (state, payload) => {
          state.selected.subFolder = payload;
        },
        SET_SELECTED_DOCUMENTS: (state, payload) => {
          state.selected.documents = payload.sort(function(a,b){
            return new Date(b.created_at) - new Date(a.created_at);
          });
        },
        SET_ROOT_FOLDERS: (state, payload) => {
          state.selected.rootFolder = null;
          state.selected.subFolder = null;
          state.rootFolders = payload.sort((a,b) => (new Date(b.created_at) - new Date(a.created_at)));
        },
        SET_SUB_FOLDERS: (state, payload) => {
          state.selected.subFolder = null;
          state.subFolders = payload.sort((a,b) => (new Date(b.created_at) - new Date(a.created_at)));
        },
        SET_DOCUMENTS: (state, payload) => {
          state.documents = payload.sort(function(a,b){
            return new Date(b.created_at) - new Date(a.created_at);
          });
        },
        APPEND_DOCUMENTS: (state, payload) => {
          state.documents = [payload, ...state.documents];
        }
    },
    actions: {
        getRecentDocuments: async (context, cmid) => {
            let res = {};
            await ApiService.get('meetingdocuments/recent/'+cmid)
                .then(response => {
                    let items = response.data;
                    var payload = [];
                    items.forEach((document) => {
                        payload.push({
                            name: {value: document.name},
                            dateUpdated: {value: formatDate(document.created_at, constants.DD_MM_YYYY)},
                            filePath:{value:filePath(document.uri)},
                            actions: [{link: `/meetingdocuments/${document.id}`, icon: 'download'},
                              {link: `/meetingdocuments/${document.id}`, icon: 'show'}]
                        });
                    });

                    context.commit("SET_RECENT_DOCUMENTS", payload);
                    res = items;
                }).catch(error => {
                    res = error;
                });
            return res;
        },

      clearRootFolder: async (context) => {
        context.commit("CLEAR_SELECTED_ROOT_FOLDER");
        context.commit("CLEAR_SELECTED_SUB_FOLDER");
      },
      clearSubFolder: async (context) => {
        context.commit("CLEAR_SELECTED_SUB_FOLDER");
      },
        getRootFolders: async (context, cmid) => {
          let res = {};
          await ApiService.get('committeerootfolders/'+cmid)
              .then(response => {
                  let payload = response.data.data;
                  context.commit("SET_ROOT_FOLDERS", payload);
                  context.commit("CLEAR_SUB_FOLDERS");
                  context.commit("CLEAR_DOCUMENTS");
                  res = payload;
              }).catch(error => {
                  res = error;
              });
          return res;
        },
        getSubFolders: async (context, rootFolderId) => {
          context.commit("SET_SELECTED_ROOT_FOLDER", rootFolderId);
          context.commit("CLEAR_SELECTED_SUB_FOLDER");
          context.commit("CLEAR_SELECTED_DOCUMENTS");
          let res = [];
          await ApiService.get('meetingfolders/' + rootFolderId)
              .then(response => {
                  let payload = response.data.data;
                  context.commit("SET_SUB_FOLDERS", payload);
                  context.commit("CLEAR_DOCUMENTS");
                  res = payload;
              }).catch(error => {
                  res = error;
              });
          return res;
        },
        getDocuments: async (context, subFolderId) => {
          context.commit("SET_SELECTED_SUB_FOLDER", subFolderId);
          context.commit("CLEAR_SELECTED_DOCUMENTS");
          let res = {};
          await ApiService.get('meetingdocuments?folderid=' + subFolderId)
              .then(response => {
                  let payload = response.data;
                  payload.map(ele => {ele.isSelected = false;});
                  context.commit("SET_DOCUMENTS", payload);
                  res = payload;
              }).catch(error => {
                  res = error;
              });
          return res;
        },
        uploadDocument: (context, payload) => {
          var formData = new FormData();
          formData.append('file', payload.file);
          formData.append('folderId', payload.folderId);

          return new Promise((resolve, reject) => {
          ApiService.post('meetingdocuments', formData)
              .then(response => {
                resolve({'message':'File Uploaded!'});
              }).catch(error => {
                reject(error.response.data);
              });
            });
        },
        checkDocumentIndexService: async (context) => {
          let res = false;
          await ApiService.get('docservicehealthcheck')
              .then(response => {
                  let payload = response.data.data;
                  res = payload;
              }).catch(error => {
                  res = false;
              });
              return res;
        },
        downloadDocument: async (context, link) => {
          return new Promise((resolve, reject) => {
            ApiService.request({
            'method': 'get',
            'url': link,
            responseType: 'blob'
          }).then(response => {
                  forceDownload(response);
                  resolve({'message':'File downloaded!'});
            }).catch(error => {
              reject(error);
            });
          });
        },
        showDocument: async (context, link) => {
          return new Promise((resolve,reject)=>{
            ApiService.request({
              'method': 'get',
              'url': link,
              responseType: 'blob'
            }).then( response => {
              resolve(filePreview(response));
            })
              .catch( response => {
                console.log(response);
              });
          });
        },
        downloadBulk: async (context, ids) => {

          if (ids.length == 0) {
            return false;
          }

          let url = 'meetingdocuments/bulk';
          var formData = new FormData();
          for (let id of ids) {
            formData.append('ids[]', id);
          }
          return new Promise((resolve, reject) => {
            ApiService.request({
              'method': 'post',
              'url': url,
              'data': formData,
              responseType: 'blob'
            }).then(response => {
                  forceDownload(response);
                  resolve({'message':'File downloaded!'});
            }).catch(error => {
              reject(error);
            });
          });
        },
        searchDocuments: async (context, payload) => {
          let res = {};
          await ApiService.get('/meetingdocuments/search?term=' + payload.term+'&cmid='+payload.cmid)
              .then(response => {
                   res = response.data;
                   var payload = [];
                    res.forEach((document) => {
                        payload.push({
                            name: {value: document.name},
                            dateUpdated: {value: document.created_at},
                            actions: [{link: `/meetingdocuments/${document.id}`, icon: 'download'}]
                        });
                    });

                    context.commit("SET_RECENT_DOCUMENTS", payload);
              }).catch(error => {
                  res = error;
              });
          return res;
        },
        deleteFolderAction: async (context, payload) => {
          return new Promise((resolve, reject) => {
            ApiService.delete('meetingfolders/'+payload.folderId)
            .then(response => {
              resolve(response.data);
            }).catch(error => {
              reject(error.response.data);
            });
          });
        },
        deleteDocumentAction: async (context, payload) => {
          return new Promise((resolve, reject) => {
            ApiService.delete('meetingdocuments/'+payload.docId)
            .then(response => {
              resolve(response.data);
            }).catch(error => {
              reject(error.response.data);
            });
          });
        },
        createFolderAction: async (context, payload) => {
          var formData = new FormData();
          formData.append('folderName', payload.folderName);
          formData.append('parentFolderId', payload.parentFolderId);
          formData.append('committeeId', payload.committeeId);
          let res = {};
          return new Promise((resolve, reject) => {
            ApiService.post('meetingfolders', formData)
              .then(response => {
                resolve(response.data);
              }).catch(error => {
                reject(error.response.data);
              });
            });
        },
        folderPermission: async (context, payload) => {
          var formData = new FormData();
          formData.append('folderId', payload.folderId);
          formData.append('committeeId', payload.committeeId);
          for (let id of payload.userIds) {
            formData.append('userIds[]', id);
          }
          let res = {};
          return new Promise((resolve, reject) => {
            ApiService.post('meetingfolder/accesspermission', formData)
              .then(response => {
                resolve(response.data);
              }).catch(error => {
                reject(error.response.data);
              });
            });
        },
        deleteBulkDocuments: async (context, payload) => {
          var formData = new FormData();
          formData.append('committeeId', payload.committeeId);
          for (let id of payload.docIds) {
            formData.append('ids[]', id);
          }
          let res = {};
          return new Promise((resolve, reject) => {
            ApiService.post('meetingdocuments/delete/bulk', formData)
              .then(response => {
                resolve(response.data);
              }).catch(error => {
                reject(error.response.data);
              });
            });
        },
        getCommitteeMembers: async (context, payload) => {
          return await ApiService.get('/committees/'+payload.committeeId)
              .then(response => {
                  let payload = response.data;
                  return payload;
              }).catch(error => {
                  return error;
              });
        },
        getFolderMembers: async (context, payload) => {
          return await ApiService.get('/meetingfolder/members/'+payload.committeeId+'/'+payload.folderId)
              .then(response => {
                  let payload = response.data;
                  return payload;
              }).catch(error => {
                  return error;
              });
        }

    },

}

export default MeetingDocumentsModule;
